import PageShell from "@/components/opsiq/PageShell";
import OpsMethodology from "@/components/opsiq/OpsMethodology";

export default function MethodologyPage() {
  return (
    <PageShell
      testid="methodology-page"
      eyebrow="The 7D methodology"
      title={<>How every OpsIQ engagement <span className="italic">actually works.</span></>}
    >
      <OpsMethodology />
    </PageShell>
  );
}
